import { Component, OnInit } from '@angular/core';
import {FormGroup,FormControl,Validators} from '@angular/forms';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import * as $ from 'jquery';
declare var show_okshan_alert: Function;

@Component({
  selector: 'app-visitor-cantactus',
  templateUrl: './visitor-cantactus.component.html',
  styleUrls: ['./visitor-cantactus.component.css']
})
export class VisitorCantactusComponent implements OnInit {

  constructor(private httpserviceService:HttpserviceService) { }

  visitorContactUsFormGroup;
  visitorContactUsName;
  visitorContactUsEmail;
  visitorContactUsMessage;
  isSubmit:boolean=false;
  isLoading:boolean=true;
  requestInProcess:boolean=false;

  ngOnInit(): void {
    window.scrollTo(0, 0);
   this.visitorContactUsFormGroup= new FormGroup({
     visitorContactUsName: new FormControl("",[Validators.required]),
     visitorContactUsEmail: new FormControl("",[Validators.required,Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
     visitorContactUsMobileNo: new FormControl("",[Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"),Validators.maxLength(10)]),
     visitorContactUsMessage: new FormControl("",[Validators.required,]),
     visitorContactUsterm: new FormControl("",[Validators.required,])
   })
  }
   
   /** proceedContactUsRequest function used to proceed proceed contact us Request  */
  proceedContactUsRequest(data)
  { 
    this.isSubmit=true;     
    if(this.visitorContactUsFormGroup.valid)
    { 
    
    this.isLoading=false;  
    this.requestInProcess=true;   
    let result =this.httpserviceService.contactUsRequest(data.visitorContactUsName,data.visitorContactUsEmail,data.visitorContactUsMessage,"+91"+data.visitorContactUsMobileNo).
     pipe(retry(0)).
     subscribe((data)=>this.contactUsResponse(data),
     err => {
       this.requestInProcess=false; 
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);
       this.isLoading=true;
    })
    }
  }

  /** contactUsResponse function used to handle response */
  contactUsResponse(response)
  {
    console.log('contactUsResponse '+ response.status);
    if(response.status==="success")  
     {      
     this.isSubmit=false;   
     this.visitorContactUsFormGroup.reset();
     this.isLoading=true;
     this.requestInProcess=false;
     show_okshan_alert("Form is submitted successfully");
     }
     else
     {
     show_okshan_alert(response.reason);
     this.requestInProcess=false;
     this.isLoading=true;
     } 
  }

  

}
